import React, { useState } from "react";

import { useParams } from "react-router-dom";
import useUserProfile from "hooks/useUserProfile";
import Modal from "Common/Components/Modal";
import AgencyForm from "../Forms/AgencyForm";
import IdentityVerification from "./IdentityVerification";

const AgencyOverviewTabs = () => {
  const params = useParams();
  const [showUpdate, setShowUpdate] = useState(false);

  const toggleUpdate = () => {
    setShowUpdate(!showUpdate);
  };

  const { data, isLoading } = useUserProfile(params.id!);

  if (isLoading) return <p>Loading...</p>;
  return (
    <React.Fragment>
      <div className="grid grid-cols-1 gap-x-5 2xl:grid-cols-12">
        <div className="2xl:col-span-9">
          <div className="card">
            <div className="card-body">
              <button
                onClick={toggleUpdate}
                className="text-white self-end btn my-5 bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Update documents
              </button>

              <h6 className="mb-3 text-15">Overview</h6>
              <p className="mb-2 text-slate-500 dark:text-zink-200">
                {data?.data?.agency?.about}
              </p>
            </div>
          </div>
        </div>
        <div className="2xl:col-span-3">
          <div className="card ">
            <div className="card-body lg:max-w-[40%]">
              <h6 className="mb-4 text-15">Personal Information</h6>
              <div className="overflow-x-auto">
                <table className="w-full ltr:text-left rtl:ext-right">
                  <tbody>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Street
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.agency?.street}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Area
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.agency?.area}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Company Email
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.agency?.companyEmail}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Services
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.agency?.services.toString()}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        State
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.agency?.state}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        L . G .A
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.agency?.lga}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        C.A.C
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.agency?.cac && (
                          <a
                            href={data?.data?.agency?.cac?.url}
                            target="_blank"
                          >
                            {data?.data?.agency?.cac?.name}
                          </a>
                        )}
                      </td>
                    </tr>

                    <tr>
                      <th className="py-2 font-semibold ps-0" scope="row">
                        Utility Bill
                      </th>
                      <td className="py-2 text-right text-slate-500 dark:text-zink-200">
                        {data?.data?.agency?.utilityBill && (
                          <a
                            href={data?.data?.agency?.utilityBill?.url}
                            target="_blank"
                          >
                            {data?.data?.agency?.utilityBill?.name}
                          </a>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <IdentityVerification
            docNumber={data?.data?.employer?.docNumber!}
            docType={data?.data?.employer?.docType!}
            status={data?.data?.user?.kycStatus!}
            userId={data?.data?.user?._id!}
            verifiedInfo={data?.data?.user?.verifiedInfo!}
            userProfile={data?.data!}
            userRole="Agency"
          />
          <Modal
            show={showUpdate}
            onHide={toggleUpdate}
            id="defaultModal"
            modal-center="true"
                size="md"
          >
            <Modal.Header
              className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
              closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500"
            >
              <Modal.Title className="text-16">Update Documents</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4 overflow-y-auto">
              <AgencyForm
                onCancel={toggleUpdate}
                data={data?.data?.agency!}
                onSubmit={toggleUpdate}
              />
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AgencyOverviewTabs;
